import React from 'react';
import { withStyles, withTheme } from '@material-ui/core/styles';
import DriverInfo from './DriverInfo';
import DnsOutlinedIcon from '@material-ui/icons/DnsOutlined';
import HeaderAction from './HeaderAction';
import { format, isValid } from 'date-fns';
import appConstants from '../../../../../../../appConstants';
import { TerminalMarker } from '../../../../../../mapComponents/Markers';
import { compose } from 'recompose';

const styles = (theme) => ({
  container: {
    paddingTop: 28
  },
  headerText: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    fontWeight: 500
  },
  driverName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.textFontSize,
    fontWeight: 500,
    marginRight: 8
  },
  driverImg: {
    fontSize: 44,
    color: theme.iconColor,
    margin: '0 8',
    opacity: 0.5
  },
  imgStyle: {
    maxWidth: '44px',
    maxHeight: '44px'
  },
  headerRow: {
    paddingTop: 12,
    display: 'flex',
    justifyContent: 'space-between'
  },
  rowContainer: {
    display: 'flex'
  },
  driverNameContainer: {
    display: 'flex'
  },
  manifestClass: {
    width: '40%'
  },
  actionButtonClass: {
    borderRadius: 15,
    width: '33%'
  },
  dcrIcon: {
    transform: 'rotate(90deg)',
    fontSize: '18px',
    marginLeft: '6px',
    color: theme.iconColor
  },
  dateTimeLabelClass: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
    paddingTop: 6
  },
  dateTimeClass: {
    paddingLeft: 4
  },
  statusValue: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.textFontSize,
    fontWeight: 600
  },
  terminalName: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.textFontSize,
    fontWeight: 500,
    paddingLeft: 4
  },
  terminalNameContainer: {
    display: 'flex',
    alignItem: 'center'
  }
});

const Header = (props) => {
  const showDockReportIcon = false;
  const { classes, theme } = props;
  return (
    <div className={classes.container}>
      <div className={classes.headerText}>STOP LIST</div>
      <div className={classes.headerRow}>
        <DriverInfo key={props.driverData.driverNumber} {...props} />
        {showDockReportIcon && <DnsOutlinedIcon className={`${classes.dcrIcon} icon-dcr`} />}
        {/*hiding this icon until will implement functionality */}
        {props.driverData.terminal?.terminalCode && (
          <div className={classes.terminalNameContainer}>
            <TerminalMarker
              fillColor={theme.white}
              color={theme.iconColor}
              data={{ size: theme.headerTextFontSize16 }}
            />
            <div className={classes.terminalName}>{props.driverData.terminal.terminalCode}</div>
          </div>
        )}
      </div>
      <div className={classes.headerRow}>
        <HeaderAction {...props} />
      </div>
      {props.route.dispatchDateTime && isValid(props.route.dispatchDateTime) && (
        <div className={classes.dateTimeLabelClass}>
          Dispatch Time:
          <span className={classes.dateTimeClass}>{`${format(
            props.route.dispatchDateTime,
            appConstants.DATETYPES.DATETIME.format
          )}`}</span>
        </div>
      )}
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(Header);
